import { $, $$ } from '@utils';

function init() {
  if (!$('form')) return;

  addEventListeners();
}

function addEventListeners() {
  $$('input[type="number"]').forEach((input) => {
    input.addEventListener('keydown', restrictFormatOnInputTypeNumber);
  });
}

/**
 *
 * @param {*} event
 */

/**
 * Restricts keys in <input type="number">:
 * - Always allows digits and editing/navigation keys.
 * - Allows '.' / ',' / NumpadDecimal ONLY if the step allows decimals (step="any" or contains '.').
 */
function restrictFormatOnInputTypeNumber(event) {
  const key = event.key;

  // Editing/navigation keys always allowed
  const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Home', 'End'];
  if (event.ctrlKey || event.metaKey || event.altKey || allowedKeys.includes(key)) return;

  // Digits always allowed
  const isDigit = /^\d$/.test(key);
  if (isDigit) return;

  // Check if the step allows decimals
  const stepAttr = this.getAttribute('step') || '1';
  const decimalsAllowed = stepAttr === 'any' || stepAttr.includes('.');

  // Check if the key is a decimal separator
  const isDecimalKey = key === '.' || key === ',' || event.code === 'NumpadDecimal';

  // Allow the decimal separator only if the step permits it
  if (decimalsAllowed && isDecimalKey) return;

  // Block everything else
  event.preventDefault();
}

export default { init };
